import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'uni-leaderboard-date-range-filter',
  templateUrl: './leaderboard-date-range-filter.component.html',
  styleUrls: ['./leaderboard-date-range-filter.component.scss'],
  providers: [DatePipe]
})
export class LeaderboardDateRangeFilterComponent implements OnInit {

  @Input() placeholder: string = 'Date range';
  @Input() extraOptions: string[] = [];
  @Output() dateRange = new EventEmitter();
  @Input() chosenOption: string = '';

  currentDate = new Date();
  calenderIconSvg: string = 'https://uni-common-assets.s3.amazonaws.com/icons/system/svg/1/calendar48x48.svg';
  showOptions: boolean = false;
  selectedOption: string = '';
  startDate: any;
  endDate: any;

  @Input() filterOptions: string[] = ['Today', 'Yesterday', 'Last 7 days', 'Last 30 days'];

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
    // this.chosenOption = this.placeholder;
    this.selectedOption = this.chosenOption;
  }

  setSelectedOption(option: any): void {
    this.selectedOption = option;
    this.setDates(option);
  }

  setCustomDate(type: string, event: MatDatepickerInputEvent<Date>): void {
    type === 'endDate' ? this.endDate = event.value : this.startDate = event.value;
  }

  toggleShowOptions(): void {
    this.showOptions = !this.showOptions;
    if (!this.showOptions) {
      this.setDates('Custom');
    }
  }

  setDates(option: string): void {
    const dateToday = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    const year = this.currentDate.getFullYear();
    const month = this.currentDate.getMonth();
    const dayOfMonth = this.currentDate.getDate();
    const firstDayOfWeek = this.currentDate.getDate() - this.currentDate.getDay() + 1;
    const lastDayOfWeek = firstDayOfWeek + 6;
    const firstDayOfLastWeek = firstDayOfWeek - 7;
    const lastDayOfLastWeek = firstDayOfWeek - 1;
    if (option === 'Custom') {
      this.startDate = '';
      this.endDate = '';
    } else if (option === 'Today') {
      this.startDate = new Date(year, month, dayOfMonth);
      this.endDate = new Date(year, month, dayOfMonth);
    } else if (option === 'Yesterday') {
      this.startDate = new Date(year, month, dayOfMonth - 1);
      this.endDate = new Date(year, month, dayOfMonth - 1);
    } else if (option === 'Last 7 days') {
      this.startDate = new Date(year, month, dayOfMonth - 7);
      this.endDate = new Date(year, month, dayOfMonth - 7);
    } else if (option === 'Last 30 days') {
      this.startDate = new Date(year, month, dayOfMonth - 30);
      this.endDate = new Date(year, month, dayOfMonth - 30);
    } else if(option === 'Last 3 months') {
      this.startDate = new Date(year, month - 3, dayOfMonth);
      this.endDate = new Date(year, month, dayOfMonth);
    } else if(option === 'Last 6 months') {
      this.startDate = new Date(year, month - 6, dayOfMonth);
      this.endDate = new Date(year, month, dayOfMonth);
    } else if(option === 'Last 1 year') {
      this.startDate = new Date(year - 1, month, dayOfMonth);
      this.endDate = new Date(year, month, dayOfMonth);
    } else if(option === 'All time') {
      this.startDate = '';
      this.endDate = '';
    }
  }

  onSubmit(): void {
    this.chosenOption = this.selectedOption;
    this.dateRange.emit({
      startDate: this.startDate ? this.formatDate(this.startDate) : '',
      endDate: this.endDate ? this.formatDate(this.endDate) : '',
      filterType: this.selectedOption
    });
    this.toggleShowOptions();
  }

  formatDate(date: any): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }
}
